import device from './device';
import * as utils from './utils';
import * as variables from './variables';
import * as animations from './animations';

const mainStyle = {
    utils,
    variables,
    animations,
    device
};

export default mainStyle;
